import React, { ReactNode } from 'react';
import { LayersContainerContext, LayersContainerContextType } from './utils';

export const LayersContainerContextProvider = ({
  children,
  treeControlState,
  setTreeControlState,
}: {
  children: ReactNode;
} & LayersContainerContextType) => (
  <LayersContainerContext.Provider value={{ treeControlState, setTreeControlState }}>
    {children}
  </LayersContainerContext.Provider>
);
